export default __webpack_public_path__ + "static/media/icon-opd.8f25cb2a.svg";